// assets/cp-discount-badge.js
(function () {
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  const cfg = window.Shopify?.customerTagDiscount || null;
  const hasTag = !!(
    cfg?.enabled &&
    cfg?.customerTags?.length &&
    cfg.customerTags.some((t) => cfg.userTags?.includes(t))
  );

  function parseMoney(text) {
    if (!text) return 0;

    const clean = String(text)
      .replace(/&nbsp;/g, ' ')
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    const num = parseFloat(clean);
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  function updateBadgeForCard(card) {
    if (!card) return;

    const compareEl = card.querySelector('.cp-price__compare');
    const priceEl = card.querySelector('.cp-price__current');
    const badge = card.querySelector('.cp-discount-badge');

    if (!badge || !priceEl) return;

    if (hasTag) {
      if ((badge.dataset.finalDiscount || '').trim()) {
        badge.textContent = `-${badge.dataset.finalDiscount}%`;
        badge.style.display = '';
        badge.hidden = false;
        return;
      }
      return;
    }

    const price = parseMoney(priceEl.textContent || '');
    const compareVisible = compareEl && !compareEl.hasAttribute('hidden');
    const compare = compareVisible ? parseMoney(compareEl.textContent || '') : 0;

    if (!compare || compare <= price) {
      badge.textContent = '';
      badge.style.display = 'none';
      badge.hidden = true;
      return;
    }

    const pct = Math.round(((compare - price) * 100) / compare);

    if (pct > 0) {
      badge.textContent = `-${pct}%`;
      badge.dataset.finalDiscount = '';
      badge.style.display = '';
      badge.hidden = false;
    } else {
      badge.textContent = '';
      badge.style.display = 'none';
      badge.hidden = true;
    }
  }

  function refreshAllCards() {
    $$('.cp-card').forEach(updateBadgeForCard);
  }

  function init() {
    refreshAllCards();

    document.addEventListener('change', (ev) => {
      const input = ev.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.classList.contains('cp-swatch__input')) return;

      const card = input.closest('.cp-card');
      if (!card) return;

      requestAnimationFrame(() => updateBadgeForCard(card));
    });

    document.addEventListener('cp:variant-updated', (ev) => {
      const card = ev.target.closest?.('.cp-card') || ev.target;
      if (card?.classList?.contains('cp-card')) {
        updateBadgeForCard(card);
      }
    });

    document.addEventListener('cp:discount-visibility-updated', (ev) => {
      const card = ev.target.closest?.('.cp-card') || ev.target;
      if (card?.classList?.contains('cp-card')) {
        updateBadgeForCard(card);
      }
    });

    document.addEventListener('shopify:section:load', refreshAllCards);
    document.addEventListener('facets:updated', refreshAllCards);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }
    }, { timeout: 500 });
  } else {
    setTimeout(() => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }
    }, 250);
  }
})();